module.exports = __webpack_public_path__ + "thumb-down-100.jpg";


//////////////////
// WEBPACK FOOTER
// ../shared-components/src/assets/images/thumb-down-100.jpg
// module id = 447
// module chunks = 0